
<div class="clock-control-container">
    <!-- Loading -->
    <div *ngIf="isLoading" class="spinner-container">
        <div class="spinner"></div>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

    <!-- Sticky Pagination -->
    <div class="pagination sticky" *ngIf="!isLoading && !errorMessage">
        <div class="page-controls">
            <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Prev</button>
            <span>Page {{ currentPage }} of {{ totalPages }}</span>
            <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">
                Next
            </button>
        </div>

        <div class="page-size">
            <label for="pageSize">Page Size:</label>
            <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize(pageSize)">
                <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
            </select>
        </div>
    </div>

    <!-- Header -->
    <div class="header" *ngIf="!isLoading">
        <div class="header-copy">
            <h2>Clock Control</h2>
            <p>Manage clock device names, status, and recent sync activity.</p>
        </div>
    </div>

    <!-- Clock List -->
    <div class="clock-control-list" *ngIf="!isLoading && !errorMessage">
        <div
            *ngFor="let device of pagedClockDevices; trackBy: trackByClockId"
            class="clock-device-row"
            [class.is-inactive]="!device.isActive"
        >
            <div class="clock-device-main">
                <div class="top-line">
                    <div class="title-wrap">
                        <div class="clock-title">
                            {{ device.name || '—' }}
                        </div>

                        <span *ngIf="device.isActive" class="default-pill">Active</span>
                        <span *ngIf="!device.isActive" class="default-pill inactive">Inactive</span>
                    </div>
                </div>

                <div class="clock-details">
                    <div class="detail-item">
                        <span class="label">Device Number</span>
                        <span class="value">{{ device.deviceNumber || '—' }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="label">IP Address</span>
                        <span class="value">{{ getIpAddressLabel(device) }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="label">Coordinates</span>
                        <span class="value">{{ getCoordinatesLabel(device) }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="label">Last Sync</span>
                        <span class="value">{{ formatLastSync(device.lastSync) }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="label">ID</span>
                        <span class="value">{{ device.id }}</span>
                    </div>
                </div>
            </div>

            <div class="clock-device-actions">
                <button class="btn edit" (click)="openEditModal(device)">Edit Name</button>
                <button
                    class="btn"
                    [ngClass]="device.isActive ? 'delete' : 'make-default'"
                    (click)="confirmToggle(device)"
                >
                    {{ device.isActive ? 'Deactivate' : 'Activate' }}
                </button>
            </div>
        </div>

        <div class="empty-state" *ngIf="pagedClockDevices.length === 0">
            No clock devices found.
        </div>
    </div>

    <!-- Edit Name Modal -->
    <div *ngIf="modalOpen" class="modal-backdrop">
        <div class="modal" (click)="$event.stopPropagation()">
            <h2>Edit Clock Name</h2>

            <form #clockForm="ngForm" (ngSubmit)="submitClock(clockForm)">
                <label>Clock Name</label>
                <input
                    type="text"
                    [(ngModel)]="formModel.name"
                    name="name"
                    maxlength="150"
                    required
                />

                <div class="modal-buttons">
                    <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isSaving">
                        Cancel
                    </button>

                    <button type="submit" class="btn btn-primary save-btn" [disabled]="isSaving">
                        <span class="btn-spinner" *ngIf="isSaving"></span>
                        <span>Update</span>
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- Toggle Modal -->
    <div *ngIf="toggleConfirmOpen" class="modal-backdrop">
        <div class="modal confirm-modal" (click)="$event.stopPropagation()">
            <h2>{{ clockToToggle?.isActive ? 'Deactivate Clock' : 'Activate Clock' }}</h2>
            <p class="modal-text">
                Are you sure you want to
                <strong>{{ clockToToggle?.isActive ? 'deactivate' : 'activate' }}</strong>
                <strong>{{ clockToToggle?.name }}</strong>?
            </p>

            <div class="modal-buttons confirm-buttons">
                <button type="button" class="btn btn-secondary" (click)="cancelToggle()" [disabled]="isSaving">
                    Cancel
                </button>

                <button
                    type="button"
                    class="btn"
                    [ngClass]="clockToToggle?.isActive ? 'btn-danger' : 'btn-primary'"
                    (click)="toggleClock()"
                    [disabled]="isSaving"
                >
                    <span class="btn-spinner" *ngIf="isSaving"></span>
                    <span>{{ clockToToggle?.isActive ? 'Deactivate' : 'Activate' }}</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Toast -->
    <div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
        <img class="icon" alt="icon" />
        <span>{{ toastMessage }}</span>
    </div>
</div>